module.exports = __webpack_public_path__ + "images/emoji/space_invader.9f1d213e8386eacb1a8b.png";